import { type RenderEvent } from '@folklore/ads';
import classNames from 'classnames';
import { useState } from 'react';

import Ad, { AdProps } from '../ads/Ad';

import styles from '../../styles/blocks/ad-block.module.css';

interface AdBlockProps extends AdProps {
    className?: string | null;
}

function AdBlock({ className = null, ...props }: AdBlockProps) {
    const [isEmpty, setIsEmpty] = useState(false);
    const [isFluid, setIsFluid] = useState(false);

    const onAdRender = ({
        isEmpty: newIsEmpty = true,
        isFluid: newIsFluid = false,
    }: RenderEvent) => {
        setIsEmpty(newIsEmpty);
        setIsFluid(newIsFluid);
    };

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isEmpty]: isEmpty,
                    [styles.isFluid]: isFluid,
                },
                className,
            ])}
        >
            <Ad slot="content" className={styles.ad} onRender={onAdRender} {...props} />
        </div>
    );
}

export default AdBlock;
